import { AlertButton, IonAlert } from '@ionic/react';
import { ComponentPropsWithoutRef, FC } from 'react';
import classnames from 'classnames';
import collect from 'collect.js';

interface Props extends ComponentPropsWithoutRef<typeof IonAlert> {
  title: string;
  description?: string;
}

export enum AlertButtonRole {
  Confirm = 'confirm',
  Destructive = 'destructive',
  Cancel = 'cancel',
}

const Alert: FC<Props> = ({ title, description, buttons, cssClass, ...rest }): JSX.Element => {
  const combinedCssClass = classnames(
    '[&_.alert-title]:!text-md [&_.alert-button-group]:flex [&_.alert-button-group]:w-full [&_.alert-button-group]:justify-center [&_.alert-button]:!px-none [&_.sc-ion-alert-ios]:flex-nowrap [&_.sc-ion-alert-ios]:items-center [&_.alert-button-group]:items-center [&_.alert-button-group]:bg-blue-200 [&_.alert-button-group]:px-md [&_.alert-button-group]:pb-sm [&_.alert-button-group]:gap-x-xs [&_.alert-wrapper]:h-fit [&_.alert-wrapper]:max-w-[93%] [&_.alert-wrapper]:min-w-[93%]  [&_.alert-wrapper]:flex-col [&_.alert-wrapper]:justify-center',
    cssClass,
  );

  return (
    <IonAlert
      cssClass={combinedCssClass}
      header={title}
      message={description}
      buttons={collect(buttons as AlertButton[])
        .map((button) => ({
          ...button,
          cssClass: classnames(button?.cssClass, {
            '!text-white font-semibold h-[40px] !border-none !rounded-lg !bg-brand-primary w-full m-0':
              button?.role === AlertButtonRole.Confirm,
            '!text-white font-semibold h-[40px] !border-none !rounded-lg !bg-danger w-full m-0':
              button?.role === AlertButtonRole.Destructive,
            '!text-brand-text-primary font-semibold min-h-10 !border-none !rounded-lg !bg-mobile-notice w-full m-0':
              button?.role === AlertButtonRole.Cancel,
          }),
        }))
        .toArray()}
      {...rest}
    />
  );
};

export default Alert;
